import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';

import { RedirectionItem } from '../../types/app-redirection.types.ts';
import { getReduxStorageUtil } from '../../utils/storage/redux-storage.util.ts';

import { APP_REDIRECTION_SLICE_NAME, AppRedirectionSliceState } from './app-redirection.slice.types.ts';

export const APP_REDIRECTION_INITIAL_STATE: AppRedirectionSliceState = {
  redirectionItems: [],
};

const persistConfig = {
  key: APP_REDIRECTION_SLICE_NAME,
  storage: getReduxStorageUtil(),
  whitelist: ['redirectionItems'],
};

const appRedirectionSlice = createSlice({
  name: APP_REDIRECTION_SLICE_NAME,
  initialState: APP_REDIRECTION_INITIAL_STATE,
  reducers: {
    resetAppRedirectionSlice: () => APP_REDIRECTION_INITIAL_STATE,

    setRedirectionItems: (state, action: PayloadAction<RedirectionItem[]>) => {
      state.redirectionItems = action.payload;
    },

    addRedirectionItem: (state, action: PayloadAction<RedirectionItem>) => {
      state.redirectionItems.push(action.payload);
    },

    filterRedirectionItem: (state, action: PayloadAction<string>) => {
      const internalId = action.payload;
      if (!internalId) {
        return;
      }

      state.redirectionItems = state.redirectionItems.filter((item) => item.internalId !== internalId);
    },
  },
});

export const { resetAppRedirectionSlice, setRedirectionItems, addRedirectionItem, filterRedirectionItem } =
  appRedirectionSlice.actions;

export const AppRedirectionSlice = persistReducer(persistConfig, appRedirectionSlice.reducer);
